export default "__VITE_ASSET__I5XYsJw7__"